export default {
  meta: {
    title: '用户管理'
  }
};
